import { print } from 'graphql'
import { type ClubBenefit, type TierDefinition } from 'shopify-types'

import { storefrontClient } from '..'
import {
  FetchTierDefinitionsDocument,
  type FetchTierDefinitionsQuery,
} from '../__generated/storefront'
import { type GlobalRequestOptions } from '../types'
import { type GQLClubBenefitNode, mapGQLClubBenefit } from './clubBenefit'

const getClubBenefitNodes = (
  references:
    | {
        nodes?: Array<GQLClubBenefitNode | Record<PropertyKey, never>>
      }
    | null
    | undefined,
) => (references?.nodes ?? []) as GQLClubBenefitNode[]

const mapGQLTierDefinitionToTierDefinition = (
  tierDefinition: NonNullable<FetchTierDefinitionsQuery['metaobjects']>,
): TierDefinition[] => {
  return tierDefinition.nodes.map(node => {
    const tierDefObj: {
      handle: string
      name: string
      tagName: string
      minimumPoints: number
      permanentBenefits: ClubBenefit[]
    } = {
      handle: node.handle,
      name: '',
      tagName: '',
      minimumPoints: 0,
      permanentBenefits: [],
    }

    node.fields.forEach(field => {
      switch (field.key) {
        case 'name':
          tierDefObj.name = field.value ?? ''
          break
        case 'tagname':
          tierDefObj.tagName = field.value ?? ''
          break
        case 'minimumpoints':
          tierDefObj.minimumPoints = parseInt(field.value ?? '0')
          break
        case 'permanentbenefits':
          tierDefObj.permanentBenefits = getClubBenefitNodes(field.references).map(
            mapGQLClubBenefit,
          )
          break
      }
    })

    return tierDefObj
  })
}

export const fetchTierDefinitions =
  (options: GlobalRequestOptions) => async (): Promise<TierDefinition[]> => {
    const type = 'ClubTier'
    const response = await storefrontClient.request<FetchTierDefinitionsQuery>(
      print(FetchTierDefinitionsDocument),
      { variables: { type, language: options.language } },
    )

    if (!response.data?.metaobjects) {
      throw new Error('Failed to fetch tier definitions')
    }

    return mapGQLTierDefinitionToTierDefinition(response.data.metaobjects)
  }
